import script from "./radioBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./radioBlock.vue?vue&type=script&setup=true&lang=ts"

import "./radioBlock.vue?vue&type=style&index=0&id=9f29953a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f29953a"]])

export default __exports__